import React from 'react';
import { styled } from '@linaria/react';

import ChannelSlider from './ChannelSlider';
import RGBSnippet from './RGBSnippet';

const LABELS = {
  r: 'Red',
  g: 'Green',
  b: 'Blue',
};

function RGBColorPicker({ dynamicGradients = false }) {
  const [color, setColor] = React.useState({
    r: 255,
    g: 0,
    b: 0,
  });

  const changeColor = React.useCallback((channel, value) => {
    setColor((currentColor) => ({
      ...currentColor,
      [channel]: value,
    }));
  }, []);

  const channels = Object.keys(color);

  return (
    <Wrapper>
      <Sliders>
        {channels.map((channel) => (
          <ChannelSlider
            key={channel}
            label={LABELS[channel]}
            color={color}
            channel={channel}
            value={color[channel]}
            dynamicGradients={dynamicGradients}
            onChange={changeColor}
          />
        ))}
      </Sliders>
      <Output>
        <Preview
          style={{
            backgroundColor: `rgb(${color.r} ${color.g} ${color.b})`,
          }}
        />
        <RGBSnippet {...color} />
      </Output>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 32px;
  margin: 48px 0 96px;
`;

const Sliders = styled.div`
  flex: 10000000;
  display: flex;
  flex-direction: column;
  gap: 24px;
  min-width: 200px;
`;

const Preview = styled.div`
  flex: 1;
  width: 100%;
  min-height: 100px;
`;

const Output = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  /* Magic number calculated by having all 3 channels be 3-digit */
  min-width: 14.5rem;
  text-align: center;
  margin-top: calc(2rem + 4px);
  border: 2px solid white;
  border-radius: 2px;
  /* prettier-ignore */
  box-shadow:
    0.6px 1.3px 2.2px rgba(0, 0, 0, 0.02),
    1.5px 3.1px 5.3px rgba(0, 0, 0, 0.028),
    2.9px 5.8px 10px rgba(0, 0, 0, 0.035),
    5.1px 10.3px 17.9px rgba(0, 0, 0, 0.042),
    9.6px 19.2px 33.4px rgba(0, 0, 0, 0.05),
    23px 46px 80px rgba(0, 0, 0, 0.07);
`;

export default React.memo(RGBColorPicker);
